import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export function getCroppedImage(
  image: Entity.CroppedImage,
  size = "l"
): Entity.Image {
  return image[size];
}

export function getCroppedImageUrl(
  image: Entity.CroppedImage,
  size = "l"
): string {
  const result = getCroppedImage(image, size);
  /* tmp replace, backend issues, todo: remove */
  return String(result ? result.url : "").replace("::", ":");
}

// todo; remove it later
export function getCDNImageUrl(url: string): string {
  return String(url).replace(
    "//bitrix-dev-cloud.",
    "//storage.yandexcloud.net/content.bitrix.dev.cloud."
  );
}

export function originImage(url: string): string {
  const origin = publicRuntimeConfig.ORIGIN_HOST || "";

  if (!url) return "/";

  // todo: temp solution. remove it later
  return url.startsWith("/") ? origin + url : url;
}

export function getImageSrcWithSize(src: string, size: string): string {
  if (!src) return "";

  if (!src.startsWith("https://static.")) return originImage(src);

  const url = originImage(src);
  const urlFragments = url.split("/");
  urlFragments[urlFragments.length - 1] =
    size + urlFragments[urlFragments.length - 1];

  return urlFragments.join("/");
}
